import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { identifyComponent } from '../../../util';
import css from './index.module.scss';
import { TableBodyRowBase as TableBodyRowBaseType } from './types';

export const TableBodyRowBase: TableBodyRowBaseType = ({
  children,
  className,
  onClick,
  highlightOnHover = false,
  ...rest
}) => (
  <tr
    data-component="TableBodyRowBase"
    data-testid="table-row"
    className={classNames(className, css.tableBodyRow, {
      [css.clickable]: !!onClick,
      [css.highlight]: !!onClick || highlightOnHover,
    })}
    onClick={onClick}
    {...rest}
    {...identifyComponent('table-body-row-base', rest)}
  >
    {children}
  </tr>
);
